import React, { useCallback, useEffect, useState } from 'react';
import { View, Text,StyleSheet,TextInput, TouchableOpacity } from 'react-native';

import { navigate } from '../../../../navigation/RootNavigation';
import { TenantService } from '../../redux/tenant.service';
import PropertyCard from './components/PropertyDetailsCard';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import Pagination from '@mui/material/Pagination'
import ajax from '../../../../helpers/ajaxHelper';
import Urls from '../../../../services/Urls';
import { showErrorToast } from '../helpers';
import { useDispatch } from 'react-redux';
import HorizontalTabSliderWelcome from './components/HorizontalTabSliderWelcome';
import getPlatformType from '../../../../helpers/helpers';

const CurrentOnboards = (props) => {
  const [count, setCount] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('');
  const layout=getPlatformType();
  
  const pageCount = Math.ceil(total / pageSize)
  const [debounceSearch, setDebounceSearch] = useState('')
  const [flows, setFlows] = useState([])
  const dispatch =useDispatch()
  useEffect(() => {
    TenantService.getCount().then((response) => {
      console.log("getCount,", response)
      if (response && response?.data && response?.data?.length) {
        setCount(response?.data)
      }
    });
  }, []);
  const handlePageChange = (event, value) => {
    setPage(value)
  }
  const fetchTableData = useCallback(async () => {
    const filters = {
      pageNo: page - 1,
      search: debounceSearch,
      sortBy:"createdAt",
       sortOrder:"desc",
       pageSize:30
    }
    ajax.get(Urls.getActiveFlows, {params: filters}).then(({ data }) => {  
      if (data.status) {
        if (data?.data.flows?.length > 0) {
          setFlows(data?.data?.flows)
          setTotal(data?.data?.totalFlows)
          setPageSize(data?.data?.pageSize)
        } else {
          setFlows([])
          setTotal(0)
        }
      } else {
       showErrorToast(data.message)
      }
    }
  )
}
  )
  useEffect(() => {
    fetchTableData()
  }, [ page, debounceSearch])
  const   handlePageClick = (data) => {
    console.log('onPageChange', data);
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.perPage);

    // this.setState({ offset: offset }, () => {
    //   this.loadCommentsFromServer();
    // });
  };
  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setPage(1)
      setDebounceSearch(search)
    }, 500)

    return () => clearTimeout(delayInputTimeoutId)
  }, [search])

  const handleRowPageChange = ( e) => {
    setPageSize(e.target.value)
  }
  const handleFilter = (value) => {
    setSearch(value)
  }
  return (
<>
<HorizontalTabSliderWelcome props={props}/>
    <View style={styles.container}>  
          <Text style={styles.welcomeTitle}>Current Move in</Text>
        <Text style={styles.welcomeText}>
        Below is a list of tenants that are currently being moved in.
</Text>
<View style={{ flexDirection: layout=="phone"?'column' :'row',marginBottom: 10, justifyContent: 'space-between',gap:12 }}> 
        <TextInput
        style={styles.searchInput}
        placeholder="Search"
        value={search}
        onChangeText={handleFilter}
      />
    <TouchableOpacity
          style={[styles.button2, { opacity:  1  }]}
          onPress={() => navigate("addproperty")}
        >
          <Text style={styles.buttonText2}>+ NEW MOVE IN</Text>
        </TouchableOpacity>
      </View>
      <Text style={styles.welcomeTitl2}>
      Total matching records: {total}</Text>
      <View style={{flexDirection:"row",flexWrap:'wrap'}}>

    {flows&&flows.length? 
    flows.map((item,index)=>{
    return(

<PropertyCard
item={item}
index={index}
onRefresh={()=>fetchTableData()}
/>
    )
    }):null}
</View>
<View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
<Pagination count={pageCount} page={page} onChange={handlePageChange} color='primary' />
</View>
    </View>
    </>
  );
};



const styles = StyleSheet.create({
    welcomeTitl2: {
        fontSize: 16,
        fontWeight: '600',
        color: '#7C3AED',
        marginBottom: 20,
        marginTop:10,
        alignSelf:"flex-end"
    },
  searchInput: { borderWidth: 1, padding: 8, borderRadius: 5, borderColor: "#ccc",flex:1 },
  container: {
    padding: 20,
    backgroundColor: '#F9FAFB',
    marginVertical: 30,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    marginBottom: 20,
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  statCard: {
    width: '48%',
    padding: 15,
    borderRadius: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  statIcon: {
    marginBottom: 8,
  },
  statValue: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#374151',
  },
  statLabel: {
    fontSize: 14,
    color: '#1F2937',
  },
  notificationCard: {
    backgroundColor: '#FEF3C7',
    padding: 15,
    borderRadius: 10,
    marginBottom: 20,
  },
  notificationTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#92400E',
    marginBottom: 10,
  },
  notificationMessage: {
    fontSize: 14,
    color: '#374151',
  },
  welcomeContainer: {
    backgroundColor: '#FFFFFF',
    padding: 20,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    marginBottom: 20,
    marginTop: 20
  },
  welcomeTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#7C3AED',
    marginBottom: 10,
  },
  welcomeText: {
    fontSize: 15,
    marginBottom: 10,
    color: '#374151',
  },
  buttonGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 15,
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 18,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  button2: { backgroundColor: "#7D57C1", padding: 10, borderRadius: 5, alignItems: "center" },
  buttonText2: { color: "white", fontWeight: "bold" },
});

export default drawerHoc({
  Component: CurrentOnboards,
});
let MOCKDATA= {
  "status": true,
  "data": {
      "flows": [
          {
              "openflow_id": 2126,
              "branch_id": 268,
              "property_id": 112640,
              "agent_id": 524,
              "percentage_completed": 0,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 0,
              "property_status": 0,
              "doc_status": 0,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": false,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-18T09:59:35.448Z",
              "updatedAt": "2025-04-18T09:59:35.448Z",
              "property": {
                  "property_id": 112640,
                  "property_name": "Main Prop",
                  "postcode": "E14 0BT",
                  "address_line2": "LONDON",
                  "address_line1": "FLAT 12, LEYLAND HOUSE, HALE STREET",
                  "address_line3": null,
                  "address_line4": null,
                  "city": "LONDON",
                  "state": "",
                  "country": "UK"
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2117,
              "branch_id": 268,
              "property_id": 112640,
              "agent_id": 524,
              "percentage_completed": 0,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 0,
              "property_status": 0,
              "doc_status": 0,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": false,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-16T13:35:05.775Z",
              "updatedAt": "2025-04-17T11:54:46.561Z",
              "property": {
                  "property_id": 112640,
                  "property_name": "Main Prop",
                  "postcode": "E14 0BT",
                  "address_line2": "LONDON",
                  "address_line1": "FLAT 12, LEYLAND HOUSE, HALE STREET",
                  "address_line3": null,
                  "address_line4": null,
                  "city": "LONDON",
                  "state": "",
                  "country": "UK"
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2077,
              "branch_id": 268,
              "property_id": 112535,
              "agent_id": 524,
              "percentage_completed": 20,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 0,
              "property_status": 0,
              "doc_status": 4,
              "rental_offer_status": 4,
              "holding_deposit_status": 4,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 4,
              "verification_status": 0,
              "number_of_occupants": 2,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": true,
              "ast_generate_at": "2025-04-11T07:38:32.642Z",
              "ast_contract_url": "https://assets.openbrix.co.uk/openflow-ast-e90ly-1744357118937-0.pdf",
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": "https://assets.openbrix.co.uk/openflow-prescribed-osXRO-1744357129432-0.pdf",
              "supporting_documents_url": "https://assets.openbrix.co.uk/openflow-supporting-documents-m3dRx-1744357135739-0.pdf",
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": true,
              "is_send_document_details": true,
              "is_send_rental_offer_details": true,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-10T15:39:28.041Z",
              "updatedAt": "2025-04-16T10:11:38.974Z",
              "property": {
                  "property_id": 112535,
                  "property_name": "2 Bed, House",
                  "postcode": "IG11 7GN",
                  "address_line2": "BARKING",
                  "address_line1": "15, CRICK COURT, SPRING PLACE",
                  "address_line3": null,
                  "address_line4": null,
                  "city": "BARKING",
                  "state": "",
                  "country": "UK"
              },
              "open_flow_rental_offer": {
                  "open_flow_rental_offer_id": 1284,
                  "openflow_id": "2077",
                  "rental_amount": 12300.9,
                  "is_irp_required": true,
                  "initial_rental_amount": 12300,
                  "tenancy_deposit_amount": 14193.34,
                  "rental_due_date": 1,
                  "rental_frequency": "monthly",
                  "movein_date": "2025-04-17T15:36:17.000Z",
                  "tenancy_start_date": "2025-04-17T15:36:17.000Z",
                  "tenancy_end_date": "2026-04-16T15:36:17.000Z",
                  "tenant_gas_responsibility": true,
                  "irp_start_date": "2025-04-17T15:36:17.000Z",
                  "irp_end_date": "2025-05-17T15:36:17.000Z",
                  "tenant_broadbank_phone_responsibility": true,
                  "is_contract_send": false,
                  "tenant_council_tax_responsibility": true,
                  "tenant_tv_license_responsibility": true,
                  "tenant_water_responsibility": true,
                  "tenant_electricity_responsibility": true,
                  "is_seen_howtorent": false,
                  "break_clause": null,
                  "common_conditions": "[]",
                  "additional_conditions": "",
                  "furnished": "Furnished",
                  "is_seen_depositdoc": false,
                  "status": null,
                  "createdAt": "2025-04-10T15:40:44.942Z",
                  "updatedAt": "2025-04-14T11:14:49.699Z"
              },
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": {
                  "open_flow_holding_deposit_id": 1030,
                  "openflow_id": 2077,
                  "holding_desposit_amount": 2838.66,
                  "holding_deposit_text": null,
                  "deposit_certificate": "[]",
                  "is_holding_deposit_selected": true,
                  "is_seen": false,
                  "openflow_bank_account_id": null,
                  "holding_desposit_received_date": null,
                  "deposit_certificate_date": null,
                  "createdAt": "2025-04-10T15:40:44.983Z",
                  "updatedAt": "2025-04-14T11:14:49.785Z"
              },
              "open_flow_move_in": {
                  "open_flow_move_in_id": 1035,
                  "openflow_id": 2077,
                  "inventory_check_date": null,
                  "checkin_date": null,
                  "inventory_check_status": 0,
                  "checkin_status": 0,
                  "inventory_doc": null,
                  "inventory_doc_upload_date": null,
                  "inventory_is_seen": false,
                  "tds_is_seen": false,
                  "inventory_id": null,
                  "openflow_bank_account_id": null,
                  "open_flow_tenancy_document_scheme_id": 9,
                  "createdAt": "2025-04-10T15:40:45.074Z",
                  "updatedAt": "2025-04-14T11:14:49.801Z"
              },
              "open_flow_certificates": [
                  {
                      "certificate_id": 8175,
                      "openflow_id": 2077,
                      "certificate_upload_date": "2025-04-16T10:11:38.898Z",
                      "certificate_type": "certificates_gas",
                      "certificate_url": "https://assets.openbrix.co.uk/certificate-WCBO6-1744798298552-0.png",
                      "is_seen": false,
                      "createdAt": "2025-04-16T10:11:38.898Z",
                      "updatedAt": "2025-04-16T10:11:38.898Z"
                  },
                  {
                      "certificate_id": 8094,
                      "openflow_id": 2077,
                      "certificate_upload_date": "2025-04-10T15:41:04.804Z",
                      "certificate_type": "certificates_pat",
                      "certificate_url": "https://assets.openbrix.co.uk/certificate-TUfXr-1744299664264-0.png",
                      "is_seen": false,
                      "createdAt": "2025-04-10T15:41:04.804Z",
                      "updatedAt": "2025-04-16T10:11:38.898Z"
                  }
              ],
              "open_flow_landlords": [
                  {
                      "open_flow_landlord_id": 1748,
                      "openflow_id": 2077,
                      "name": null,
                      "first_name": "Shahad",
                      "last_name": "Choudhury",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": "07592396976",
                      "email": "shahadchoudhury324@gmail.com",
                      "correspondece_address": "36 Axis House, 262 Lewisham High Street.",
                      "post_code": "SE136AD",
                      "is_england_address": true,
                      "number_england": "",
                      "email_england": "",
                      "correspondece_address_england": "",
                      "post_code_england": "",
                      "envtoken": null,
                      "title": "Mr",
                      "is_lead": true,
                      "is_email_verified": false,
                      "email_verification_token": "5UNNKEHVHUZXRWH4XMG5",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-10T15:40:18.378Z",
                      "updatedAt": "2025-04-10T15:40:18.378Z"
                  }
              ],
              "open_flow_guarantors": [],
              "fccReferences": [
                  {
                      "reference_id": 754,
                      "openflow_subtenant_id": 2904,
                      "guarantor_id": null,
                      "flow_id": 2077,
                      "fcc_reference_id": "XEUCCBBHDFE2364",
                      "url": "https://portal.paragonsecure.com/application/?TSrequestID=5ABC9F8DAD85BDBD92729E086B7C9A71AEFC8F87BAA09CFDAAFAED",
                      "url_admin": "https://admin.paragonsecure.com/referencing/?ASrequestID=7ABC9FADAD91ABC38F73965A475CBD578BE1BBAE928FBDAEEDA5B68A99BC9442489E5200B03FDA689BCED26FD09DAC8D3E92AEBE254DE2A3D62F5E6CBE2EBB99B1A295A80D4C0303",
                      "property_id_fcc": "112535_2077",
                      "completed": false,
                      "digital": false,
                      "external_otp": "uo0c7lt2hy",
                      "createdAt": "2025-04-10T15:41:38.988Z",
                      "updatedAt": "2025-04-10T16:16:32.901Z"
                  }
              ],
              "open_flow_rent_collection": null,
              "tenants": [],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2038,
              "branch_id": 268,
              "property_id": 112640,
              "agent_id": 524,
              "percentage_completed": 47.5,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 0,
              "property_status": 1,
              "doc_status": 1,
              "rental_offer_status": 4,
              "holding_deposit_status": 4,
              "move_in_status": 1,
              "gurantor_status": 0,
              "landlord_status": 4,
              "verification_status": 0,
              "number_of_occupants": 1,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": true,
              "ast_generate_at": "2025-04-10T16:51:14.925Z",
              "ast_contract_url": "https://assets.openbrix.co.uk/openflow-ast-ViYBI-1744303878999-0.pdf",
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": "https://assets.openbrix.co.uk/openflow-prescribed-wDf5d-1744303885103-0.pdf",
              "supporting_documents_url": "https://assets.openbrix.co.uk/openflow-supporting-documents-pHZAG-1744303890187-0.pdf",
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "zsdsdd",
              "movein_payee_ref": "assas",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": true,
              "is_send_tenant_details": true,
              "is_send_document_details": true,
              "is_send_rental_offer_details": true,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": true,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-04T10:13:28.206Z",
              "updatedAt": "2025-04-16T11:58:20.016Z",
              "property": {
                  "property_id": 112640,
                  "property_name": "Main Prop",
                  "postcode": "E14 0BT",
                  "address_line2": "LONDON",
                  "address_line1": "FLAT 12, LEYLAND HOUSE, HALE STREET",
                  "address_line3": null,
                  "address_line4": null,
                  "city": "LONDON",
                  "state": "",
                  "country": "UK"
              },
              "open_flow_rental_offer": {
                  "open_flow_rental_offer_id": 1279,
                  "openflow_id": "2038",
                  "rental_amount": 2138,
                  "is_irp_required": true,
                  "initial_rental_amount": 2138,
                  "tenancy_deposit_amount": 10690,
                  "rental_due_date": 2,
                  "rental_frequency": "week",
                  "movein_date": "2025-04-17T07:51:02.000Z",
                  "tenancy_start_date": "2025-04-17T07:51:02.000Z",
                  "tenancy_end_date": "2026-04-16T07:51:02.000Z",
                  "tenant_gas_responsibility": true,
                  "irp_start_date": "2025-04-17T07:51:02.000Z",
                  "irp_end_date": "2025-05-17T07:51:02.000Z",
                  "tenant_broadbank_phone_responsibility": true,
                  "is_contract_send": false,
                  "tenant_council_tax_responsibility": true,
                  "tenant_tv_license_responsibility": true,
                  "tenant_water_responsibility": true,
                  "tenant_electricity_responsibility": true,
                  "is_seen_howtorent": false,
                  "break_clause": null,
                  "common_conditions": "[]",
                  "additional_conditions": "",
                  "furnished": "Furnished",
                  "is_seen_depositdoc": false,
                  "status": null,
                  "createdAt": "2025-04-10T07:53:01.775Z",
                  "updatedAt": "2025-04-11T09:42:24.473Z"
              },
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": {
                  "open_flow_holding_deposit_id": 1025,
                  "openflow_id": 2038,
                  "holding_desposit_amount": 2138,
                  "holding_deposit_text": "",
                  "deposit_certificate": "[]",
                  "is_holding_deposit_selected": true,
                  "is_seen": false,
                  "openflow_bank_account_id": 310,
                  "holding_desposit_received_date": null,
                  "deposit_certificate_date": null,
                  "createdAt": "2025-04-10T07:53:01.800Z",
                  "updatedAt": "2025-04-11T10:20:42.590Z"
              },
              "open_flow_move_in": {
                  "open_flow_move_in_id": 1030,
                  "openflow_id": 2038,
                  "inventory_check_date": null,
                  "checkin_date": null,
                  "inventory_check_status": 0,
                  "checkin_status": 0,
                  "inventory_doc": null,
                  "inventory_doc_upload_date": null,
                  "inventory_is_seen": false,
                  "tds_is_seen": false,
                  "inventory_id": null,
                  "openflow_bank_account_id": 310,
                  "open_flow_tenancy_document_scheme_id": 5,
                  "createdAt": "2025-04-10T07:53:01.882Z",
                  "updatedAt": "2025-04-11T10:39:55.578Z"
              },
              "open_flow_certificates": [
                  {
                      "certificate_id": 8109,
                      "openflow_id": 2038,
                      "certificate_upload_date": "2025-04-11T09:35:59.877Z",
                      "certificate_type": "certificates_gas",
                      "certificate_url": "https://assets.openbrix.co.uk/certificate-djF62-1744364158772-0.png",
                      "is_seen": false,
                      "createdAt": "2025-04-11T09:35:59.877Z",
                      "updatedAt": "2025-04-11T09:36:04.778Z"
                  }
              ],
              "open_flow_landlords": [
                  {
                      "open_flow_landlord_id": 1744,
                      "openflow_id": 2038,
                      "name": null,
                      "first_name": "Shahad",
                      "last_name": "Choudhury",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": "07592396976",
                      "email": "shahadchoudhury231214@gmail.com",
                      "correspondece_address": "36 Axis House, 262 Lewisham High Street.",
                      "post_code": "SE136AD",
                      "is_england_address": true,
                      "number_england": "",
                      "email_england": "",
                      "correspondece_address_england": "",
                      "post_code_england": "",
                      "envtoken": null,
                      "title": "Mr",
                      "is_lead": true,
                      "is_email_verified": false,
                      "email_verification_token": "ZP5PQFECABSJQUCCMCCF",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-10T07:51:55.339Z",
                      "updatedAt": "2025-04-10T11:57:10.085Z"
                  }
              ],
              "open_flow_guarantors": [],
              "fccReferences": [
                  {
                      "reference_id": 750,
                      "openflow_subtenant_id": null,
                      "guarantor_id": null,
                      "flow_id": 2038,
                      "fcc_reference_id": "CHOUDHURXHF235885",
                      "url": "https://portal.paragonsecure.com/application/?TSrequestID=5ABC9F8DAD85BDBD92729E0870718067A9F6989DA6AE9FFDAAF9E1DC8A",
                      "url_admin": "https://admin.paragonsecure.com/referencing/?ASrequestID=7ABC9FADAD91ABC38F73965A475CBD578BE1BBAE928FBDAEEDA5B68A99BC9442489E5200B03FDA689BCED26FD09DAC8D3E92AEBE254DE2A3D6345376A829B18EABBE9BAB0D4C000FEECB",
                      "property_id_fcc": "112640_2038",
                      "completed": true,
                      "digital": false,
                      "external_otp": "qliw89bhkx",
                      "createdAt": "2025-04-10T09:26:34.888Z",
                      "updatedAt": "2025-04-10T16:34:02.180Z"
                  },
                  {
                      "reference_id": 751,
                      "openflow_subtenant_id": 2863,
                      "guarantor_id": null,
                      "flow_id": 2038,
                      "fcc_reference_id": "GUNWANTBEBB236335",
                      "url": "https://portal.paragonsecure.com/application/?TSrequestID=5ABC9F8DAD85BDBD92729E08746C8165ACF0998DBBA49BFDAAFAEAD78A",
                      "url_admin": "https://admin.paragonsecure.com/referencing/?ASrequestID=7ABC9FADAD91ABC38F73965A475CBD578BE1BBAE928FBDAEEDA5B68A99BC9442489E5200B03FDA689BCED26FD09DAC8D3E92AEBE254DE2A3D6304E77AA2CB78FBBA391AF0D4C0304E5CB",
                      "property_id_fcc": "112640_2038",
                      "completed": true,
                      "digital": false,
                      "external_otp": "32b62e2wayi",
                      "createdAt": "2025-04-10T09:26:48.070Z",
                      "updatedAt": "2025-04-10T16:37:31.174Z"
                  }
              ],
              "open_flow_rent_collection": null,
              "tenants": [],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2037,
              "branch_id": 268,
              "property_id": 112593,
              "agent_id": 524,
              "percentage_completed": 18,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 4,
              "property_status": 0,
              "doc_status": 4,
              "rental_offer_status": 4,
              "holding_deposit_status": 4,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": 1,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": true,
              "is_send_document_details": false,
              "is_send_rental_offer_details": true,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-04T09:55:43.794Z",
              "updatedAt": "2025-04-10T15:38:34.625Z",
              "property": {
                  "property_id": 112593,
                  "property_name": "221 Baker Street Westminster",
                  "postcode": "NW1 6XE",
                  "address_line2": "Baker Street",
                  "address_line1": "221",
                  "address_line3": "London",
                  "address_line4": "",
                  "city": null,
                  "state": null,
                  "country": null
              },
              "open_flow_rental_offer": {
                  "open_flow_rental_offer_id": 1283,
                  "openflow_id": "2037",
                  "rental_amount": 45600,
                  "is_irp_required": true,
                  "initial_rental_amount": 45600,
                  "tenancy_deposit_amount": 4384.61,
                  "rental_due_date": 1,
                  "rental_frequency": "annually",
                  "movein_date": "2025-04-24T15:36:17.000Z",
                  "tenancy_start_date": "2025-04-24T15:36:17.000Z",
                  "tenancy_end_date": "2026-04-23T15:36:17.000Z",
                  "tenant_gas_responsibility": true,
                  "irp_start_date": "2025-04-24T15:36:17.000Z",
                  "irp_end_date": "2025-05-24T15:36:17.000Z",
                  "tenant_broadbank_phone_responsibility": true,
                  "is_contract_send": false,
                  "tenant_council_tax_responsibility": true,
                  "tenant_tv_license_responsibility": true,
                  "tenant_water_responsibility": true,
                  "tenant_electricity_responsibility": true,
                  "is_seen_howtorent": false,
                  "break_clause": null,
                  "common_conditions": "[{\"clause_id\":15,\"header\":\"Gardening Clause \",\"text\":\"Notwithstanding Clause 3.14.13  hereinbefore detailed the Landlord agrees to provide and pay for the services of a gardener between the months of May to September as required but at least every two weeks to maintain the grass, boarders, hedges, trees and large shrubs.  The terms of clause 3.14.13 remain the responsibility of the Tenant \",\"createdAt\":\"2021-05-14T10:46:19.358Z\",\"updatedAt\":\"2021-05-14T10:46:19.358Z\"}]",
                  "additional_conditions": "",
                  "furnished": "Furnished",
                  "is_seen_depositdoc": false,
                  "status": null,
                  "createdAt": "2025-04-10T15:38:23.240Z",
                  "updatedAt": "2025-04-10T15:38:23.240Z"
              },
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": {
                  "open_flow_holding_deposit_id": 1029,
                  "openflow_id": 2037,
                  "holding_desposit_amount": 876.92,
                  "holding_deposit_text": null,
                  "deposit_certificate": "[]",
                  "is_holding_deposit_selected": true,
                  "is_seen": false,
                  "openflow_bank_account_id": null,
                  "holding_desposit_received_date": null,
                  "deposit_certificate_date": null,
                  "createdAt": "2025-04-10T15:38:23.279Z",
                  "updatedAt": "2025-04-10T15:38:23.279Z"
              },
              "open_flow_move_in": {
                  "open_flow_move_in_id": 1034,
                  "openflow_id": 2037,
                  "inventory_check_date": null,
                  "checkin_date": null,
                  "inventory_check_status": 0,
                  "checkin_status": 0,
                  "inventory_doc": null,
                  "inventory_doc_upload_date": null,
                  "inventory_is_seen": false,
                  "tds_is_seen": false,
                  "inventory_id": null,
                  "openflow_bank_account_id": null,
                  "open_flow_tenancy_document_scheme_id": 1,
                  "createdAt": "2025-04-10T15:38:23.299Z",
                  "updatedAt": "2025-04-10T15:38:23.299Z"
              },
              "open_flow_certificates": [],
              "open_flow_landlords": [
                  {
                      "open_flow_landlord_id": 1747,
                      "openflow_id": 2037,
                      "name": null,
                      "first_name": "Shahad",
                      "last_name": "Choudhury",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": "4366347347",
                      "email": "shahadchoudhury2411241@hotmail.co.uk",
                      "correspondece_address": "36 Axis House",
                      "post_code": "SE13 6AD",
                      "is_england_address": true,
                      "number_england": "",
                      "email_england": "",
                      "correspondece_address_england": "",
                      "post_code_england": "",
                      "envtoken": null,
                      "title": "Mr",
                      "is_lead": true,
                      "is_email_verified": false,
                      "email_verification_token": "UZNFETBTQVRMVQ26M746",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-10T15:37:54.210Z",
                      "updatedAt": "2025-04-10T15:37:54.210Z"
                  }
              ],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [
                  {
                      "open_flow_sub_tenant_id": 2903,
                      "openflow_id": 2037,
                      "app_user_id": 5109,
                      "is_lead": true,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 1,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": "2025-04-10T15:38:27.011Z",
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": "2025-04-10",
                      "createdAt": "2025-04-10T15:37:22.265Z",
                      "updatedAt": "2025-04-10T15:38:34.528Z",
                      "app_user": {
                          "app_user_id": 5109,
                          "user_id": 6073,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "JEAVBB7AC",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": "lead-0196205a-2f49-787b-b769-6923e37c2e7a",
                          "creditladder_access_token": "",
                          "creditladder_code": "",
                          "tenancy_reg_status": "",
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": true,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": "[]",
                          "reapit_contact_id": null,
                          "show_ledger_history": true,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "",
                          "app_version": "",
                          "campaign": "",
                          "new_postcode_search": null,
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2025-04-10T15:37:22.192Z",
                          "updatedAt": "2025-04-10T15:38:23.456Z",
                          "user": {
                              "user_id": 6073,
                              "first_name": "hotty",
                              "last_name": "holboutne",
                              "postcode": "SE136AD",
                              "email": "hittyholborne@yopmail.com",
                              "password": "7XC3G2VSV",
                              "contact_number": "07592396976",
                              "address": "36 Axis House, 262 Lewisham High Street.",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2025-04-10T15:37:21.541Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": false,
                              "user_profile_photo": "",
                              "title": "Mr",
                              "nationality": null,
                              "createdAt": "2025-04-10T15:37:21.541Z",
                              "updatedAt": "2025-04-10T15:38:34.484Z"
                          }
                      },
                      "open_flow_verifications": []
                  }
              ],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2033,
              "branch_id": 268,
              "property_id": 112640,
              "agent_id": 524,
              "percentage_completed": 0,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 0,
              "property_status": 0,
              "doc_status": 0,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": false,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-04T08:07:48.933Z",
              "updatedAt": "2025-04-04T08:07:48.933Z",
              "property": {
                  "property_id": 112640,
                  "property_name": "Main Prop",
                  "postcode": "E14 0BT",
                  "address_line2": "LONDON",
                  "address_line1": "FLAT 12, LEYLAND HOUSE, HALE STREET",
                  "address_line3": null,
                  "address_line4": null,
                  "city": "LONDON",
                  "state": "",
                  "country": "UK"
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2005,
              "branch_id": 268,
              "property_id": 112629,
              "agent_id": 524,
              "percentage_completed": 10,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 4,
              "property_status": 0,
              "doc_status": 4,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": false,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-02T13:29:18.277Z",
              "updatedAt": "2025-04-03T14:16:13.577Z",
              "property": {
                  "property_id": 112629,
                  "property_name": "Stamford Bridge Fulham Road",
                  "postcode": "SW6 1HS",
                  "address_line2": "Stamford Bridge Fulham Road",
                  "address_line1": "",
                  "address_line3": "London",
                  "address_line4": "",
                  "city": null,
                  "state": null,
                  "country": null
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [
                  {
                      "open_flow_landlord_id": 1692,
                      "openflow_id": 2005,
                      "name": null,
                      "first_name": "Miggy",
                      "last_name": "King",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": null,
                      "email": "miggy@Yopmaol.com",
                      "correspondece_address": null,
                      "post_code": null,
                      "is_england_address": true,
                      "number_england": null,
                      "email_england": null,
                      "correspondece_address_england": null,
                      "post_code_england": null,
                      "envtoken": null,
                      "title": "Mr",
                      "is_lead": false,
                      "is_email_verified": false,
                      "email_verification_token": "MHAKCEUT7D8RPVSBDKUU",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-02T13:29:19.149Z",
                      "updatedAt": "2025-04-02T13:29:19.149Z"
                  }
              ],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [
                  {
                      "open_flow_sub_tenant_id": 2834,
                      "openflow_id": 2005,
                      "app_user_id": 4194,
                      "is_lead": true,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": null,
                      "createdAt": "2025-04-03T14:16:13.493Z",
                      "updatedAt": "2025-04-03T14:16:13.493Z",
                      "app_user": {
                          "app_user_id": 4194,
                          "user_id": 5100,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "KMTFR3D7J",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": null,
                          "creditladder_access_token": "",
                          "creditladder_code": "",
                          "tenancy_reg_status": "",
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": false,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": "[]",
                          "reapit_contact_id": null,
                          "show_ledger_history": true,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "",
                          "app_version": "",
                          "campaign": "",
                          "new_postcode_search": null,
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2025-02-25T08:53:08.099Z",
                          "updatedAt": "2025-02-25T08:53:08.099Z",
                          "user": {
                              "user_id": 5100,
                              "first_name": "asc",
                              "last_name": "asd",
                              "postcode": "PL23 1AB",
                              "email": "1shahad5@yopmail.com",
                              "password": "9JGURQWYM",
                              "contact_number": "07592396976",
                              "address": "4 Custom House Hill",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2025-02-25T08:53:07.386Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": false,
                              "user_profile_photo": "",
                              "title": "Mr",
                              "nationality": null,
                              "createdAt": "2025-02-25T08:53:07.386Z",
                              "updatedAt": "2025-04-03T14:16:13.456Z"
                          }
                      },
                      "open_flow_verifications": []
                  }
              ],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2004,
              "branch_id": 268,
              "property_id": 112630,
              "agent_id": 524,
              "percentage_completed": 10,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 4,
              "property_status": 0,
              "doc_status": 4,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 4,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": true,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-02T12:50:46.355Z",
              "updatedAt": "2025-04-04T10:27:09.320Z",
              "property": {
                  "property_id": 112630,
                  "property_name": "180 High Rd",
                  "postcode": "N17 0BX",
                  "address_line2": "High Rd",
                  "address_line1": "180",
                  "address_line3": "London",
                  "address_line4": "",
                  "city": null,
                  "state": null,
                  "country": null
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [
                  {
                      "open_flow_landlord_id": 1691,
                      "openflow_id": 2004,
                      "name": null,
                      "first_name": "Sunita",
                      "last_name": "Williams",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": null,
                      "email": "sunita@yopmail.com",
                      "correspondece_address": null,
                      "post_code": null,
                      "is_england_address": true,
                      "number_england": null,
                      "email_england": null,
                      "correspondece_address_england": null,
                      "post_code_england": null,
                      "envtoken": null,
                      "title": "Mrs",
                      "is_lead": false,
                      "is_email_verified": false,
                      "email_verification_token": "KNV8SGMU4GNANKGZ2HAZ",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-02T12:50:48.063Z",
                      "updatedAt": "2025-04-02T12:50:48.063Z"
                  },
                  {
                      "open_flow_landlord_id": 1690,
                      "openflow_id": 2004,
                      "name": null,
                      "first_name": "",
                      "last_name": "Kings Guard",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": null,
                      "email": "kings.guard@example.com",
                      "correspondece_address": null,
                      "post_code": null,
                      "is_england_address": true,
                      "number_england": null,
                      "email_england": null,
                      "correspondece_address_england": null,
                      "post_code_england": null,
                      "envtoken": null,
                      "title": "",
                      "is_lead": false,
                      "is_email_verified": false,
                      "email_verification_token": "EFVCYN6EQUX3Z9PDGTEG",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-02T12:50:48.062Z",
                      "updatedAt": "2025-04-02T12:50:48.062Z"
                  }
              ],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [
                  {
                      "open_flow_sub_tenant_id": 2848,
                      "openflow_id": 2004,
                      "app_user_id": 2953,
                      "is_lead": true,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": "2025-04-04",
                      "createdAt": "2025-04-04T10:13:21.301Z",
                      "updatedAt": "2025-04-04T10:27:09.259Z",
                      "app_user": {
                          "app_user_id": 2953,
                          "user_id": 3499,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "6394E5757",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": null,
                          "creditladder_access_token": "",
                          "creditladder_code": "true",
                          "tenancy_reg_status": null,
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": false,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": "[]",
                          "reapit_contact_id": null,
                          "show_ledger_history": true,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "unknown",
                          "app_version": null,
                          "campaign": "",
                          "new_postcode_search": "e140bt",
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2023-09-18T07:59:47.240Z",
                          "updatedAt": "2023-09-18T08:46:19.626Z",
                          "user": {
                              "user_id": 3499,
                              "first_name": "aweqe",
                              "last_name": "qweqweqe",
                              "postcode": "PL23 1AB",
                              "email": "shahad55@yopmail.com",
                              "password": "$2b$04$jrCuDjqWr2t84t8ngw7XyuLyPMWO7yY7.UFsY5QGxTWpwT6ERt6cq",
                              "contact_number": "07592396976",
                              "address": "4 Custom House Hill",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2023-09-18T08:51:27.690Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": true,
                              "user_profile_photo": "",
                              "title": "",
                              "nationality": null,
                              "createdAt": "2023-09-18T07:59:47.218Z",
                              "updatedAt": "2025-04-04T10:27:09.080Z"
                          }
                      },
                      "open_flow_verifications": []
                  },
                  {
                      "open_flow_sub_tenant_id": 2852,
                      "openflow_id": 2004,
                      "app_user_id": 5045,
                      "is_lead": false,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": "2025-04-04",
                      "createdAt": "2025-04-04T10:17:12.161Z",
                      "updatedAt": "2025-04-04T10:27:09.246Z",
                      "app_user": {
                          "app_user_id": 5045,
                          "user_id": 5993,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "QSJ6UZG2F",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": null,
                          "creditladder_access_token": "",
                          "creditladder_code": "",
                          "tenancy_reg_status": "",
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": false,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": "[]",
                          "reapit_contact_id": null,
                          "show_ledger_history": true,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "",
                          "app_version": "",
                          "campaign": "",
                          "new_postcode_search": null,
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2025-04-04T10:17:12.077Z",
                          "updatedAt": "2025-04-04T10:17:12.077Z",
                          "user": {
                              "user_id": 5993,
                              "first_name": "HITESH",
                              "last_name": "GUNWANT",
                              "postcode": "PL23 1AB",
                              "email": "shahad54@yopmail.com",
                              "password": "ZUYRJGY6Q",
                              "contact_number": "07592396976",
                              "address": "asdasd",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2025-04-04T10:17:12.024Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": false,
                              "user_profile_photo": "",
                              "title": "",
                              "nationality": null,
                              "createdAt": "2025-04-04T10:17:12.024Z",
                              "updatedAt": "2025-04-04T10:27:09.175Z"
                          }
                      },
                      "open_flow_verifications": []
                  },
                  {
                      "open_flow_sub_tenant_id": 2850,
                      "openflow_id": 2004,
                      "app_user_id": 1777,
                      "is_lead": false,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": null,
                      "createdAt": "2025-04-04T10:14:06.018Z",
                      "updatedAt": "2025-04-04T10:16:52.218Z",
                      "app_user": {
                          "app_user_id": 1777,
                          "user_id": 2115,
                          "idverification": 5,
                          "idverification_started_at": "2025-04-04T14:40:29.725Z",
                          "lite_referencing_status": 2,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "XMQM7E4BV",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": "e3pfuaGgRIKVa5q8lxSZth:APA91bGZBrcBRFq995WIE4hGFiCvOUV5bawv47xHoNfdjxuJvq_2UG8LSwt3Kx7beIUoeV2iaSUeai4w6N2XGMW55RgPCyrj8i5PugSH16X14vq6H2aiWoBk2RNuTTXcctOLhEiYhkp8",
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": "lead-01961eb0-23ad-774c-8227-8e761569b0fe",
                          "creditladder_access_token": "",
                          "creditladder_code": "true",
                          "tenancy_reg_status": null,
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": true,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": null,
                          "reapit_contact_id": null,
                          "show_ledger_history": null,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "web",
                          "app_version": null,
                          "campaign": null,
                          "new_postcode_search": "E14 0BT",
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2022-12-02T11:17:48.961Z",
                          "updatedAt": "2025-04-10T07:53:02.140Z",
                          "user": {
                              "user_id": 2115,
                              "first_name": "Shahad",
                              "last_name": "Test",
                              "postcode": "PL23 1AB",
                              "email": "shahad5@yopmail.com",
                              "password": "$2b$04$TfRaDR0reRNQRMcjlH85neNZpxCzxEBA1At3JuhkhjBUyQL1SvkE.",
                              "contact_number": "32423423434",
                              "address": "4 Custom House Hill",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2024-05-01T08:48:33.190Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": true,
                              "user_profile_photo": "",
                              "title": "Miss",
                              "nationality": null,
                              "createdAt": "2022-12-02T11:17:48.939Z",
                              "updatedAt": "2025-04-11T10:08:11.394Z"
                          }
                      },
                      "open_flow_verifications": []
                  },
                  {
                      "open_flow_sub_tenant_id": 2851,
                      "openflow_id": 2004,
                      "app_user_id": 5044,
                      "is_lead": false,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": "2025-04-04",
                      "createdAt": "2025-04-04T10:16:20.927Z",
                      "updatedAt": "2025-04-04T10:27:09.256Z",
                      "app_user": {
                          "app_user_id": 5044,
                          "user_id": 5992,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "GWXFYWBCH",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": null,
                          "creditladder_access_token": "",
                          "creditladder_code": "",
                          "tenancy_reg_status": "",
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": false,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": "[]",
                          "reapit_contact_id": null,
                          "show_ledger_history": true,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "",
                          "app_version": "",
                          "campaign": "",
                          "new_postcode_search": null,
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2025-04-04T10:16:20.856Z",
                          "updatedAt": "2025-04-04T10:16:20.856Z",
                          "user": {
                              "user_id": 5992,
                              "first_name": "HITESH",
                              "last_name": "GUNWANT",
                              "postcode": "PL23 1AB",
                              "email": "shahad58@yopmail.com",
                              "password": "X4XQ3HPQY",
                              "contact_number": "07592396976",
                              "address": "4 Custom House Hill",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2025-04-04T10:16:20.278Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": false,
                              "user_profile_photo": "",
                              "title": "",
                              "nationality": null,
                              "createdAt": "2025-04-04T10:16:20.278Z",
                              "updatedAt": "2025-04-04T10:27:09.178Z"
                          }
                      },
                      "open_flow_verifications": []
                  },
                  {
                      "open_flow_sub_tenant_id": 2849,
                      "openflow_id": 2004,
                      "app_user_id": 1776,
                      "is_lead": false,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": "2025-04-04",
                      "createdAt": "2025-04-04T10:14:02.378Z",
                      "updatedAt": "2025-04-04T10:27:09.264Z",
                      "app_user": {
                          "app_user_id": 1776,
                          "user_id": 2114,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "3CVLSY3A4",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": null,
                          "creditladder_access_token": "",
                          "creditladder_code": "",
                          "tenancy_reg_status": null,
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": false,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": null,
                          "reapit_contact_id": null,
                          "show_ledger_history": null,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "unknown",
                          "app_version": null,
                          "campaign": null,
                          "new_postcode_search": null,
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2022-12-02T11:17:48.951Z",
                          "updatedAt": "2022-12-02T11:17:48.951Z",
                          "user": {
                              "user_id": 2114,
                              "first_name": "asdas",
                              "last_name": "sdfsdf",
                              "postcode": "PL23 1AB",
                              "email": "shahad5@yopmail.com",
                              "password": "$2b$04$QqiVVSypFBcD9npFYrlXreNEA0c1uHazov28NfHKMNiSbubrCWdEK",
                              "contact_number": "32423423434",
                              "address": "4 Custom House Hill",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2022-12-02T11:17:48.931Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": false,
                              "user_profile_photo": "",
                              "title": "Miss",
                              "nationality": null,
                              "createdAt": "2022-12-02T11:17:48.932Z",
                              "updatedAt": "2025-04-10T11:13:59.726Z"
                          }
                      },
                      "open_flow_verifications": []
                  }
              ],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2003,
              "branch_id": 268,
              "property_id": 112629,
              "agent_id": 524,
              "percentage_completed": 2,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 0,
              "property_status": 0,
              "doc_status": 4,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": false,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-02T12:47:46.717Z",
              "updatedAt": "2025-04-02T12:47:48.196Z",
              "property": {
                  "property_id": 112629,
                  "property_name": "Stamford Bridge Fulham Road",
                  "postcode": "SW6 1HS",
                  "address_line2": "Stamford Bridge Fulham Road",
                  "address_line1": "",
                  "address_line3": "London",
                  "address_line4": "",
                  "city": null,
                  "state": null,
                  "country": null
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [
                  {
                      "open_flow_landlord_id": 1689,
                      "openflow_id": 2003,
                      "name": null,
                      "first_name": "Miggy",
                      "last_name": "King",
                      "ast_sent_at": null,
                      "contract_sent_at": null,
                      "number": null,
                      "email": "miggy@yopmail.com",
                      "correspondece_address": null,
                      "post_code": null,
                      "is_england_address": true,
                      "number_england": null,
                      "email_england": null,
                      "correspondece_address_england": null,
                      "post_code_england": null,
                      "envtoken": null,
                      "title": "Mr",
                      "is_lead": false,
                      "is_email_verified": false,
                      "email_verification_token": "PSUK52RPMA438PYAGFCV",
                      "reapit_landlord_id": null,
                      "is_contract_emailed": false,
                      "createdAt": "2025-04-02T12:47:48.154Z",
                      "updatedAt": "2025-04-02T12:47:48.154Z"
                  }
              ],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          },
          {
              "openflow_id": 2002,
              "branch_id": 268,
              "property_id": 112629,
              "agent_id": 524,
              "percentage_completed": 6,
              "renewed_from": null,
              "is_renewed": false,
              "is_archived": false,
              "is_completed": false,
              "tenancy_status": 4,
              "property_status": 0,
              "doc_status": 0,
              "rental_offer_status": 0,
              "holding_deposit_status": 0,
              "move_in_status": 0,
              "gurantor_status": 0,
              "landlord_status": 0,
              "verification_status": 0,
              "number_of_occupants": null,
              "how_to_rent_pdf_url": null,
              "is_ast_generated": false,
              "ast_generate_at": null,
              "ast_contract_url": null,
              "ast_contract_signed_url": null,
              "ast_uploaded_at": null,
              "uploaded_ast_contract_url": null,
              "prescribed_contract_url": null,
              "supporting_documents_url": null,
              "additional_conditions": null,
              "common_conditions": null,
              "break_clause": null,
              "envid": null,
              "is_nha_generated": false,
              "nha_generate_at": null,
              "nha_contract_url": null,
              "is_added_to_property": false,
              "is_ast_signed": false,
              "is_deleted": false,
              "payee_ref": "",
              "movein_payee_ref": "",
              "is_prescribed_contract_seen": false,
              "is_supporting_documents_seen": false,
              "is_movein_money_received_by_landlord": false,
              "is_holding_deposit_received_by_landlord": false,
              "is_rental_payment_received_by_landlord": false,
              "is_flow_used": false,
              "holding_deposit_collection_from_lead_tenant": false,
              "move_in_money_from_lead_tenant": false,
              "is_show_save_continue_popup": true,
              "is_send_movein_details": false,
              "is_send_tenant_details": false,
              "is_send_document_details": false,
              "is_send_rental_offer_details": false,
              "is_send_deposit_setup_details": false,
              "is_send_holding_deposit_details": false,
              "is_bespoke_contract_uploaded": false,
              "bb_opt_out": true,
              "bespoke_contract_url": null,
              "reapit_tenancy_id": null,
              "reapit_applicant_id": null,
              "reapit_landlord_id": null,
              "besponse_contract_uploaded_at": null,
              "createdAt": "2025-04-02T12:46:37.907Z",
              "updatedAt": "2025-04-02T12:46:40.088Z",
              "property": {
                  "property_id": 112629,
                  "property_name": "Stamford Bridge Fulham Road",
                  "postcode": "SW6 1HS",
                  "address_line2": "Stamford Bridge Fulham Road",
                  "address_line1": "",
                  "address_line3": "London",
                  "address_line4": "",
                  "city": null,
                  "state": null,
                  "country": null
              },
              "open_flow_rental_offer": null,
              "agent": {
                  "agent_id": 524,
                  "unique_display_id": "F01230C",
                  "branch_id": 268,
                  "user_id": 3845,
                  "displays_per_page": null,
                  "is_branch_admin": true,
                  "is_company_admin": true,
                  "is_group_admin": false,
                  "can_add_bank_accounts": true,
                  "website": null,
                  "is_active": true,
                  "fcm_registration_token": "cPbQUFSc2bXL0vWqZqLzu0:APA91bFoyIAFHATZp7XIcSD2ai7rPl773jw58CvGhtlz7haVeJqk4Ey0xKtne6tpdxOwTRr7i0f_s5gcNs_8Mg3hvr9V1a_qp_CYJdAVfne4r35dkMdSDMBx3tpckIMwDCCsyeSFb3QR",
                  "createdAt": "2024-02-27T15:24:45.440Z",
                  "updatedAt": "2025-04-17T08:31:06.531Z",
                  "user": {
                      "user_id": 3845,
                      "first_name": "Mikel",
                      "last_name": "Angelo",
                      "email": "mikelangeloestates@yopmail.com"
                  }
              },
              "open_flow_holding_deposit": null,
              "open_flow_move_in": null,
              "open_flow_certificates": [],
              "open_flow_landlords": [],
              "open_flow_guarantors": [],
              "fccReferences": [],
              "open_flow_rent_collection": null,
              "tenants": [
                  {
                      "open_flow_sub_tenant_id": 2822,
                      "openflow_id": 2002,
                      "app_user_id": 5030,
                      "is_lead": false,
                      "is_contract_emailed": false,
                      "is_ast_signed": false,
                      "rental_offer_status": 0,
                      "rental_offer_accepted_at": null,
                      "contract_sent_at": null,
                      "ast_sent_at": null,
                      "full_referencing_status": 0,
                      "full_referencing_started_at": null,
                      "movein_money_accepted_at": null,
                      "movein_money_sent_at": null,
                      "movein_money_received_date": null,
                      "movein_money_status": 0,
                      "deposit_accepted_at": null,
                      "deposit_sent_at": null,
                      "date_received_deposit": null,
                      "deposit_payment_status": 0,
                      "uploaded_ast_contract_url": null,
                      "ast_uploaded_at": null,
                      "rental_offer_sent_at": null,
                      "envtoken": null,
                      "show_card": false,
                      "is_guarantor_information_requested": false,
                      "reapit_tenancy_id": null,
                      "tenant_detail_confirmed": false,
                      "tenant_detail_confirmed_at": null,
                      "tenant_detail_send_at": null,
                      "createdAt": "2025-04-02T12:46:39.309Z",
                      "updatedAt": "2025-04-02T12:46:39.309Z",
                      "app_user": {
                          "app_user_id": 5030,
                          "user_id": 5976,
                          "idverification": 0,
                          "idverification_started_at": null,
                          "lite_referencing_status": 0,
                          "full_referencing_status": 0,
                          "full_referencing_started_at": null,
                          "opbrix_id": "4MXNSJSRN",
                          "yoti_verification_document": null,
                          "propertysaved": "",
                          "fcm_registration_token": null,
                          "fcm_web_registration_token": null,
                          "creditladder_refresh_token": "",
                          "home_reference": null,
                          "creditladder_access_token": "",
                          "creditladder_code": "",
                          "tenancy_reg_status": "",
                          "creditladder_stripe_subscription_id": null,
                          "agreed_to_concierge_service": false,
                          "is_sent_to_home": false,
                          "property_notification": false,
                          "marketplace_notification": false,
                          "rental_notification": false,
                          "maintenance_notification": false,
                          "openflow_notification": true,
                          "yoti_reason": null,
                          "yoti_sessions": "[]",
                          "reapit_contact_id": null,
                          "show_ledger_history": true,
                          "right_to_rent_requested": false,
                          "right_to_rent_expiry": null,
                          "right_to_rent": null,
                          "right_to_rent_dob": null,
                          "stripe_customer_id": null,
                          "right_to_rent_document": null,
                          "right_to_rent_approved": false,
                          "registered_from": "",
                          "platform": "",
                          "app_version": "",
                          "campaign": "",
                          "new_postcode_search": null,
                          "tenant_insurance_click_count": 0,
                          "share_yoti_id": true,
                          "share_pre_qualification": true,
                          "share_right_to_rent": true,
                          "share_affordability": true,
                          "share_rental_ledger": true,
                          "registration_refrence": null,
                          "createdAt": "2025-04-02T12:46:39.250Z",
                          "updatedAt": "2025-04-02T12:46:39.250Z",
                          "user": {
                              "user_id": 5976,
                              "first_name": "Miggy",
                              "last_name": "King",
                              "postcode": "",
                              "email": "take@yopmail.com",
                              "password": "5GQFMYAPY",
                              "contact_number": "234342432",
                              "address": "",
                              "is_delete": 0,
                              "facebook_id": null,
                              "google_id": null,
                              "access_token": null,
                              "reset_code": null,
                              "is_superuser": false,
                              "tabIndex": 0,
                              "skipDirectDebit": false,
                              "last_login": "2025-04-02T12:46:38.781Z",
                              "guide_complete": false,
                              "show_wizard": true,
                              "is_registered": false,
                              "user_profile_photo": "",
                              "title": "Mr",
                              "nationality": null,
                              "createdAt": "2025-04-02T12:46:38.781Z",
                              "updatedAt": "2025-04-02T12:46:38.781Z"
                          }
                      },
                      "open_flow_verifications": []
                  }
              ],
              "tenancy_message": null,
              "tenancy_button_text": null,
              "doc_message": null,
              "doc_button_text": null,
              "property_message": null,
              "property_button_text": null,
              "move_in_message": null,
              "move_in_button_text": null,
              "landlord_message": null,
              "landlord_button_text": null,
              "rental_offer_message": null,
              "rental_offer_button_text": null,
              "verification_message": null,
              "verification_button_text": null,
              "holding_deposit_message": null,
              "holding_deposit_button_text": null
          }
      ],
      "totalFlows": 75,
      "pageSize": 10
  }
}